import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./Layout";
import Dashboard from "./Dashboard";
import Plans from "./Plans";
import AddPlan from "./AddPlan";
import EditPlan from "./EditPlan";
import DeletePlan from "./DeletePlan";
import Lists from "./Lists";
import AddList from "./AddList";
import EditList from "./EditList";
import { AuthProvider } from "./AuthProvider";
import RequireAuth from "./RequireAuth";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import AccountUsers from "./AccountUsers";
import AddUserAccount from "./AddUserAccount";
import EditUserAccount from "./EditUserAccount";
import FlowSettings from "./FlowSettings";

function App() {
	return (
		<BrowserRouter future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
			<AuthProvider>
				<Routes>
					<Route path="login" element={<Login />} />
					<Route path="forgot-password" element={<ForgotPassword />} />
					<Route path="reset-password" element={<ResetPassword />} />
					<Route path="/" element={<Layout />}>
						<Route element={<RequireAuth />}>
							<Route index element={<Navigate to="/dashboard" replace />} />
							<Route path="/dashboard/*" element={<Dashboard />} />
							<Route path="/plans" element={<Plans />} />
							<Route path="/add-plan" element={<AddPlan />} />
							<Route path="/edit-plan/:planId" element={<EditPlan />} />
							<Route path="/delete-plan/:planId" element={<DeletePlan />} />
							<Route path="/lists" element={<Lists />} />
							<Route path="/add-list" element={<AddList />} />
							<Route path="/edit-list/:listId" element={<EditList />} />
							<Route path="/account-users" element={<AccountUsers />} />
							<Route path="/add-account-users" element={<AddUserAccount />} />
							<Route path="/edit-account-user/:userId" element={<EditUserAccount />} />
							<Route path="/flow-settings" element={<FlowSettings />} />
						</Route>
					</Route>
				</Routes>
			</AuthProvider>
		</BrowserRouter>
	);
}

export default App;
